import { IDME_COUPONS } from '@pff-consumer/schema'
import { invertObject } from '../common'
import { capitalize } from '../format/format'

const GROUP_LABEL_MAP: Record<string, string> = {
  responder: 'First Responder',
}

const idMeCouponToGroupMap = invertObject(IDME_COUPONS)

export const getIdmeGroupInfo = (coupon: string): { groupLabel?: string; isIdme: boolean } => {
  const idMeUserGroup = idMeCouponToGroupMap[coupon]
  if (!idMeUserGroup) return { isIdme: false }

  const groupLabel = GROUP_LABEL_MAP[idMeUserGroup] || capitalize(idMeUserGroup)
  return { groupLabel, isIdme: true }
}
